import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloudUpload from '@material-ui/icons/CloudUpload';

import readXlsxFile from 'read-excel-file'

import './index.scss';

class MenuBar extends Component {
  constructor() {
    super()

    this.uploadSheet = this.uploadSheet.bind(this)
  }

  uploadSheet = event => {
    const uploadedFile = event.target.files[0]

    this.props.onChange([])
    readXlsxFile(uploadedFile).then((rows) => {
      this.props.onChange(this.extractFromSheet(rows))
    })
  }

  extractFromSheet = rows => {
    rows.shift()
    const data = rows.map(r => {
      return {
        examRollNumber: r[1],
        studentName: r[2],
        tuRedgNum: r[4],
        year: r[6]
      }
    })
    return data
  }

  render() {
    return (
      <AppBar position="fixed">
        <Container className="menu-container">
          <Toolbar>
            <IconButton edge="start" className="menu-button" color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" className="menu-title" noWrap>
              {this.props.appData?.college}
            </Typography>
            <div className="right-buttons">
              <input
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                className="file"
                id="contained-button-file"
                multiple
                type="file"
                  onChange={this.uploadSheet}
                  hidden
              />
              <label htmlFor="contained-button-file">
                <Button className="btn-upload" variant="contained" color="default" component="span">
                  <CloudUpload />
                  Upload Sheet
                </Button>
              </label>

              <Button color="inherit" className="login-button">Login</Button>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
    )
  }
}

MenuBar.propTypes = {
  onChange: PropTypes.func,
  appData: PropTypes.object
}

export default MenuBar
